/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {shopSearchProducts} from '../api'

export const useMutationShopSearchProducts = createReactQueryMutationHook('shopSearchProducts', shopSearchProducts)
